import { render, staticRenderFns } from "./CollectedDataChart.vue?vue&type=template&id=b3fb820e&"
import script from "./CollectedDataChart.vue?vue&type=script&lang=ts&"
export * from "./CollectedDataChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports